import MessagingShared from "../../components/MessagingShared";
export default function PadreMensajeria() {
    return <MessagingShared allowedRoles={["profesor", "psicologo"]} />;
}
